export default __webpack_public_path__ + "static/media/mdi_tick-circle.31fd3b2e.svg";